module.exports = __webpack_public_path__ + "img/WechatIMG78.b15fcce7.jpeg";